<template>
  <b-card>
    <alert ref="alert" />
    <div v-if="showSpinner" class="loader-wrapper">
      <div class="loader"></div>
    </div>
    <alert ref="alert"/>
    <b-tabs card>
      <b-tab title="Forgot Password Request" title-link-class="nav-link-custom" active>
        <b-row class="row offset-2 col-5 col-lg-4 col-xl-3">
          <b-form @submit="onSubmit" class="w-100" align="center">
            <b-form-group label="E-mail" label-for="email" label-class="text-left">
              <ValidationProvider name="email" rules="required|email" v-slot="v">
                <b-input-group>
                  <b-form-input
                    id="email"
                    v-model="form.email"
                    required
                    placeholder="Your email that was used for registration"
                    aria-describedby="emailErrors"
                    size="sm">
                  </b-form-input>
                  <b-form-invalid-feedback style="display: block; text-align: left" id="emailErrors">{{ v.errors[0] }}</b-form-invalid-feedback>
                </b-input-group>
              </ValidationProvider>
            </b-form-group>

            <b-button
              :disabled="form.email === ''"
              type="submit" variant="primary" size="sm" class="float-right">Request</b-button>
          </b-form>
        </b-row>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import Alert from '../Alert';

import axios from 'axios';
import { ValidationProvider, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

axios.defaults.baseURL = API_BASE_URL;

extend('required', {
  ...required,
  message: 'This field is required'
});
extend('email', {
  ...email,
  message: 'Email does not seem valid'
});

export default {
  props: {
    path: String
  },
  data() {
    return {
      form: {
        email: ''
      },
      showSpinner: false,
      alert: {
        timestamp: 0,
        type: '',
        msg: ''
      }
    };
  },
  methods: {
    async onSubmit(evt) {
      this.showSpinner = true;
      evt.preventDefault();
      try {
        let res = await axios.post('/users/reset', {
          'Email': this.form.email
        });
        this.$refs.alert.showAlert('success', 'If you were registered in the system, you should receive the email with a link to proceed.');
      } catch (err) {
        this.$refs.alert.showAlert('danger', 'Failed to form a password reset request.');
      } finally {
        this.showSpinner = false;
      }
    }
  },
  components: {
    Alert,
    ValidationProvider
  }
};
</script>

<style lang="scss" scoped>
.nav-tabs {
  .nav-link-custom,
  &.active {
    border-color: #dee2e6 !important;
    border-radius: 0.25rem !important;
  }
}

.pwd-btn {
  padding: 0.25rem 0.35rem;
}
</style>
